<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h5>Add External SIP Profile</h5>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="intercom_external_sip.name">
            <small class="form-text text-muted">.xml not required.</small>
          </div>
          <div class="form-group">
            <label for="txtConditionExpression">Condition Expression</label>
            <input type="text" class="form-control" id="txtConditionExpression" v-model="intercom_external_sip.condition_expression">
          </div>
          <div class="form-group">
            <label for="txtGateway">Gateway</label>
            <input type="text" class="form-control" id="txtGateway" v-model="intercom_external_sip.gateway">
          </div>
          <div class="form-group">
            <label for="txtUsername">Username</label>
            <input type="text" class="form-control" id="txtUsername" v-model="intercom_external_sip.username">
          </div>
          <div class="form-group">
            <label for="txtAuthUsername">Auth-Username</label>
            <input type="text" class="form-control" id="txtAuthUsername" v-model="intercom_external_sip.auth_username">
          </div>
          <div class="form-group">
            <label for="txtRealm">Realm</label>
            <input type="text" class="form-control" id="txtRealm" v-model="intercom_external_sip.realm">
          </div>
          <div class="form-group">
            <label for="txtPassword">Password</label>
            <input type="text" class="form-control" id="txtPassword" v-model="intercom_external_sip.password">
          </div>
          <div class="form-group">
            <label for="txtProxy">Proxy</label>
            <input type="text" class="form-control" id="txtProxy" v-model="intercom_external_sip.proxy">
          </div>
          <div class="form-group">
            <label for="txtExpireSeconds">Expire Seconds</label>
            <input type="text" class="form-control" id="txtExpireSeconds" v-model="intercom_external_sip.expire_seconds">
          </div>
          <div class="form-group">
            <label for="txtRegister">Register</label>
            <input type="text" class="form-control" id="txtRegister" v-model="intercom_external_sip.register">
          </div>
          <div class="form-group">
            <label for="txtRetrySeconds">Retry Seconds</label>
            <input type="text" class="form-control" id="txtRetrySeconds" v-model="intercom_external_sip.retry_seconds">
          </div>
          <div class="form-group">
            <label for="txtDtmfType">DTMF Type</label>
            <input type="text" class="form-control" id="txtDtmfType" v-model="intercom_external_sip.dtmf_type">
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
          <router-link :to="{ name: 'AdminExternalSipIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      intercom_external_sip: {
        intercom_external_sip_id: 0,
        site_id: 0,
        name: 'default',
        condition_expression: '^9(\\d{10})$',
        gateway: '',
        username: '',
        auth_username: '',
        realm: '',
        password: '',
        proxy: '',
        expire_seconds: 600,
        register: true,
        retry_seconds: 30,
        dtmf_type: 'rfc2833'
      }
    }
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
  },
  methods: {
    submit () {
      this.$store.dispatch('addEditIntercomExternalSip', this.intercom_external_sip)
    }
  }
}
</script>

<style scoped>

</style>
